import { chain, contains } from 'underscore';
import { useSiteConfig } from '@bingads-webui-campaign-react/smart-page-context';
import {
  componentsConfig,
  getComponentByType,
} from '@bingads-webui-campaign-react/smart-component-util';
import {
  SmartActionButtonTypes,
  proxyReadFromCTAComponentConfig,
} from '@bingads-webui-campaign-react/smart-component-action-button';
import { getActionTypesForContactComponent } from '@bingads-webui-campaign-react/smart-component-contact';

const ContactMethodActionTypes = [
  SmartActionButtonTypes.CallNow.name,
  SmartActionButtonTypes.SendMail.name,
  SmartActionButtonTypes.GetDirections.name,
];

export const useActionButtons = () => {
  const { siteConfig } = useSiteConfig();
  const ctaComponentConfig = getComponentByType(siteConfig, componentsConfig.callToAction.type);
  const { actionType: ctaActionType } = proxyReadFromCTAComponentConfig(ctaComponentConfig);
  const contactComponentConfig = getComponentByType(siteConfig, componentsConfig.contact.type);
  const actionTypesInContact = getActionTypesForContactComponent(contactComponentConfig);

  const actionTypes = chain(ContactMethodActionTypes)
    .filter(type => contains(actionTypesInContact, type))
    .without(ctaActionType)
    .map(type => ({ actionType: type }))
    .value();

  return actionTypes;
};
